module.exports = __webpack_public_path__ + "static/trees-3.7-a0d4eb1b0c5f49e064b09b2290837e46.png";